import { render, staticRenderFns } from "./submenuItem.vue?vue&type=template&id=3c0c2829&"
import script from "./submenuItem.vue?vue&type=script&lang=js&"
export * from "./submenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports